/**
 * The base error class for all errors thrown by the Design System.
 */
export class BSWDesignSystemError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'BSWDesignSystemError';
  }
}
